import permission from '@/permission';
export default {
  install: function install(Vue) {
    // v-permission=""
    Vue.directive('permission', {
      inserted: function inserted(el, binding) {
        var modifiers = binding.modifiers,
            value = binding.value;
        var has = permission(value, modifiers);
        if (!has) el.parentNode && el.parentNode.removeChild(el);
      }
    }); // this.$permission()

    Vue.prototype.$permission = permission;
  }
};